if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
}

jQuery(function($){

  resizeWindow();

  $(window).resize(resizeWindow);
  
  // marquee
  if ($('#marquee').length) {
    $('#marquee .marquee').marquee({
      speed: 100,
      startVisible: true,
      duplicated: true
    });
  }
  
  // mobile nav
  $('#header .toggle').on('click tap', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#mobile_nav').css('z-index', '9998').fadeIn(300);
  });	
  $('#mobile_nav .close').on('click tap', function() {
    $('#mobile_nav').fadeOut(300, function() {
      $(this).css('z-index', '-1');
    });
  });	
  
  // popup
  if ($('#popup').length) {
    if(typeof(Storage) !== "undefined") {
      if (sessionStorage.ironsideShowPopup != 1) {
        $('html, body').addClass('frozen');
        $('#popup').show(0);
      }
    }
  }
  $('#popup .close_popup').on('click tap', function() {
    $('#popup').fadeOut(300, function() {
      $('html, body').removeClass('frozen');
      sessionStorage.ironsideShowPopup = 1;
    });
  });
  
  // parallax
  if ($('.paroller').length) {
    $('.paroller, [data-paroller-factor]').paroller({
      factor: 0.3,
      factorXs: 0.1,
      type: 'background',
      direction: 'vertical',
      transition: 'transform 0.2s ease-in'
    });
  }
  
  // home: products slider
  if ($('#home .products .slider').length) {
    $('#home .products .slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true
    });
    $('#home .products .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('#home .products .nav div').removeClass('active');
      $('#home .products .nav div[rel="' + nextSlide + '"]').addClass('active');
    });
    $('#home .products .nav div').on('click tap', function() {
      var rel = $(this).attr('rel');
      $('#home .products .slider').slick('slickGoTo', rel);
    });
  }
  
  // home: reviews slider
  if ($('#home .reviews .slider').length) {
    $('#home .reviews .slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false
    });
    $('#home .reviews .slider').on('init', function(event, slick){
      $('#home .reviews .arrows .pager').text(parseInt(slick.currentSlide + 1) + ' / ' + slick.slideCount);
    });
    $('#home .reviews .slider').on('afterChange', function(event, slick, currentSlide){
      $('#home .reviews .arrows .pager').text(parseInt(slick.currentSlide + 1) + ' / ' + slick.slideCount);
      $('#home .reviews .nav h2 span').text(parseInt(slick.currentSlide + 1));
    });
    $('#home .reviews .arrows .arrow-left').on('click tap', function() {
      $('#home .reviews .slider').slick('slickPrev');
    });
    $('#home .reviews .arrows .arrow-right').on('click tap', function() {
      $('#home .reviews .slider').slick('slickNext');
    });
  }
  
  // product images & thumbs sliders
  if ($('#product .images .slider').length) {
    $('#product .images .slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '#product .details .slider'
    });
  }
  if ($('#product .details .slider').length) {
    $('#product .details .slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '#product .images .slider',
      focusOnSelect: true,
    });
  }

  // bundle product vertical thumbs
  $('#product .images.images-bundle .vertical-thumbs .thumb').on('click tap', function() {
    $('#product .images.images-bundle .vertical-thumbs .thumb').removeClass('active');
    $(this).addClass('active');
    $('#product .images .slider').slick('slickGoTo',$(this).index());
  });
  
  // product accordions
  $('#product .details .accordion .item .label').on('click tap', function() {
    $(this).parent().toggleClass('open');
    $(this).next().slideToggle('fast');
  });
  
  // faqs accordion
  $('#faqs .accordion .item .label').on('click tap', function() {
    $(this).parent().toggleClass('open');
    $(this).next().slideToggle('fast');
  });
	  
});
	
function resizeWindow() {

  var ww = $(window).width();
  var wh = $(window).height();
  
  // marquee
  if ($('#marquee').length) {
    var mh = $('#marquee').outerHeight();
    $('#header').css('top', mh + 'px');
  }
  
  // padtop
  if ($('#padtop').length) {
    var hh = $('#header').outerHeight();
    if ($('#marquee').length) {
      hh = hh + $('#marquee').outerHeight();
    }
    $('#padtop').css('height', hh + 'px');
  }
  if ($('#mobile_padtop').length) {
    var hh = $('#header').outerHeight();
    if ($('#marquee').length) {
      hh = hh + $('#marquee').outerHeight();
    }
    $('#mobile_padtop').css('height', hh + 'px');
  }
  
  // our story
  if ($('#story').length) {
    var imgH = ( ww * 922 ) /  1440;
    var margT = 0.3 * imgH * -1;
    $('#story .text').css('margin-top', margT + 'px'); 
  }
  					 					
}